import React, { memo } from "react";

const ValuePropsLite = () => (
  <div className="container">
    <h2 className="heading--xl">Discover. Find. Buy.</h2>
    <p className="my-xl text-sm">
      We’re the world’s destination to discover, find, and buy cannabis.
    </p>
    <p className="my-xl text-sm">
      Our vision is a world where everyone can experience the benefits of
      cannabis.
    </p>
    <p className="my-xl text-sm">
      Leafly is the world’s online destination to learn about cannabis, find
      cannabis strains and products, and buy them from legal, licensed
      retailers. More than 100 million people visit us each year because of our
      proven commitment to education and science-based information.
    </p>
  </div>
);

export default memo(ValuePropsLite);
